import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const OLStyled = styled.ol`
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();

    return css`
      display: flex;
      flex-direction: ${mediumUp ? 'row' : 'column'};
      list-style: none;
      padding: 0;
      margin: 0;
    `;
  }}
`;

export const LIStyled = styled.li`
    ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const xlargeUp = theme.xlargeUp();
    let colWidth = 100;
    let horizontalPadding = 0;

    if(xlargeUp){
      horizontalPadding = rem(60);
    }else if(mediumUp){
      horizontalPadding = rem(10);
    }

    if(mediumUp){
      colWidth = (100/3);
    }

    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      width: ${`${colWidth}%`};
      text-align: center;
      padding: 0 ${horizontalPadding };
    `;
  }}
`;
export const TypographyListCopyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${mediumUp && 'padding-bottom: 0;'};
    `;
  }}
`;

export const TypographyListNumberStyled = styled(Typography)`
    ${({ theme }) => {
    return css`
      display: block;
      color: ${theme.colors.blue.blue};
    `;
  }}
`;
